import React, { useState, useEffect } from "react";
import { string, func, bool } from "prop-types";
import Loader from "react-loader-advanced";
import { ThreeBounce } from "better-react-spinkit";
import thumbsUp from "resources/images/thumbsUp-outline.svg";
import thumbsDown from "resources/images/thumbsDown-outline.svg";

const ResponseSection = ({
  handleSendResponseFeedback,
  questionAsked,
  responseId,
  sendingBotQuestion,
  supportBotResponse,
  supportBotResponseError,
}) => {
  const [feedbackSelected, setFeedbackSelected] = useState(0); // 1 = thumbs down (low quality), 2 = thumbs up (high quality)

  useEffect(() => {
    if (responseId) {
      setFeedbackSelected("");
    }
  }, [responseId]);

  const onSendResponseFeedback = (responseQuality) => {
    setFeedbackSelected(responseQuality);
    handleSendResponseFeedback(responseQuality);
  };

  const getResponseFeedback = () => {
    const ThumbsUpImg = <img src={thumbsUp} width="16px" alt="thumbs-up" />;
    const ThumbsDownImg = (
      <img src={thumbsDown} width="16px" alt="thumbs-down" />
    );

    if (!feedbackSelected) {
      return (
        <>
          <span className="align-self-end mr-2">Is this helpful?</span>
          <button type="button" onClick={() => onSendResponseFeedback(2)}>
            {ThumbsUpImg}
          </button>
          <button type="button" onClick={() => onSendResponseFeedback(1)}>
            {ThumbsDownImg}
          </button>
        </>
      );
    }

    return (
      <>
        <span className="align-self-center mr-2">
          Thank you for your feedback!
        </span>
        <span className="span-label">
          {feedbackSelected === 2 ? ThumbsUpImg : ThumbsDownImg}
        </span>
      </>
    );
  };

  return (
    <div
      className="generated-response-wrapper mb-2"
      style={{
        minHeight: "100px",
        backgroundColor: supportBotResponse ? "#F5F7FC" : "#FFF",
      }}
    >
      <Loader
        show={sendingBotQuestion}
        message={<ThreeBounce color="#1F469A" size={20} />}
        contentBlur={30}
        messageStyle={{ height: "100px" }}
        backgroundStyle={{ backgroundColor: "rgba( 0 0 0 0)" }}
      >
        {supportBotResponseError ? (
          <span className="error-message">
            The Helper Center Assistant is not able to respond at this moment.
            Please try again later.
          </span>
        ) : null}
        {supportBotResponse ? (
          <div className="generated-response">
            <div className="px-3 pt-3">
              <span className="span-label px-2">{questionAsked}</span>
            </div>
            <div
              className="p-3"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: supportBotResponse.replace(/\n/g, "<br />"),
              }}
            />
            <div className="response-feedback p-3" style={{ color: "#425CC7" }}>
              <p className="d-flex justify-content-end">
                {getResponseFeedback()}
              </p>
            </div>
          </div>
        ) : null}
      </Loader>
    </div>
  );
};

ResponseSection.propTypes = {
  handleSendResponseFeedback: func,
  questionAsked: string,
  responseId: string,
  sendingBotQuestion: bool,
  supportBotResponse: string,
  supportBotResponseError: bool,
};

export default ResponseSection;
